enum CognitoStatus {
    FoundAndConfirmed = "FoundAndConfirmed",
    FoundAndUnconfirmed = "FoundAndUnconfirmed",
    NotFound = "NotFound"
}

export default CognitoStatus;